export const POWER_OF_TEN_ATHLETE_LINK =
  'https://www.thepowerof10.info/athletes/profile.aspx?ukaurn='
